import { useState } from 'react';
import { Dimensions, ScaledSize } from 'react-native';
import useUnmount from './useUnmount';
import useMount from './useMount';

/**
 * A hook for tracking window/screen size.
 *
 * @param canvasType type of the canvas to track 'window' or 'screen'.
 * @param cb callback to capture canvas size.
 */
export const useCanvasSize = (
  canvasType: 'window' | 'screen',
): ScaledSize => {
  const [state, setState] = useState(null);

  const onChange = (canvas): void => {
    setState(canvas[canvasType]);
  };

  useMount(() => {
    setState(Dimensions.get(canvasType));
    Dimensions.addEventListener('change', onChange);
  });

  useUnmount(() => {
    setState(null);
    Dimensions.removeEventListener('change', onChange);
  }, []);

  return state;
};

export default useCanvasSize;
